import store from '@/store'
import enObj from  './en'

let en = enObj.en

export default {
  translate(str) {
    let language = store.getters.language
    if(language == 'CN'){
      return str
    }else{
      if(en[str]){
        return en[str]
      }else{
        return str
      }
    }
  }
}